<script>
import axios from 'axios';
import html2canvas from 'html2canvas';
import NumberOfInjuriesIllnesses
  from "@/components/dashboard/accident-incident/SafetyAndHealth/NumberOfInjuriesIllnesses.vue";
import LossWorkingCase from "@/components/dashboard/accident-incident/SafetyAndHealth/LossWorkingCase.vue";
import NumberOfInjuryPart from "@/components/dashboard/accident-incident/SafetyAndHealth/NumberOfInjuryPart.vue";
import NumberOfIllnessPart from "@/components/dashboard/accident-incident/SafetyAndHealth/NumberOfIllnessPart.vue";
import {mapActions, mapGetters} from "vuex";
import appLoading from "@/components/elements/AppLoading.vue";
import {DashboardService} from "@/services/DashboardService";
import {ExcelService} from "@/services/ExcelService";
import {permissionMixin} from "@/mixins/permissionMixins";
import NumberOfInjuriesByManning
  from "@/components/dashboard/accident-incident/SafetyAndHealth/NumberOfInjuriesByManning.vue";
import NumberOfIllnessesByManning
  from "@/components/dashboard/accident-incident/SafetyAndHealth/NumberOfIllnessesByManning.vue";
import NumberOfInjuriesByRank
  from "@/components/dashboard/accident-incident/SafetyAndHealth/NumberOfInjuriesByRank.vue";
import NumberOfIllnessesByRank
  from "@/components/dashboard/accident-incident/SafetyAndHealth/NumberOfIllnessesByRank.vue";

export default {
  name: "SafetyAndHealth",
  mixins : [permissionMixin],
  components: {
    NumberOfIllnessesByRank,
    NumberOfInjuriesByRank,
    NumberOfInjuriesByManning,
    NumberOfIllnessesByManning,
    appLoading, NumberOfIllnessPart, NumberOfInjuryPart, LossWorkingCase, NumberOfInjuriesIllnesses},
  data() {
    const currentYear = new Date().getFullYear();
    const years = Array.from({ length: 6 }, (_, i) => currentYear - 5 + i);

    return {
      years,
      tableIndex : 0,
      selectedYear : null,
    }
  },
  methods : {
    ...mapActions([
      'getAccidentSafetyAndHealthChartsData',

    ]),
    async showReport (reportId) {
      const route= this.$router.resolve(
        {
          name: 'Loss',
          params: {
            id: reportId,
          },
        },
      )
      window.open(route.href,'_blank')
    },
    async generateCsv(){
      swal.fire({
        'title': 'GENERATING CSV FILE',
        allowEscapeKey:false,
        allowEnterKey:false,
        allowOutsideClick:false,
      })
      swal.showLoading()
      await ExcelService.postCsv('SAFETY_AND_HEALTH', {
        safety_and_health_module : this.newAirSafetyAndHealthChartData.safety_and_health_module,
        file_name : `SAFETY_AND_HEALTH_${this.newAirSafetyAndHealthChartData?.text_header.toUpperCase()}.xlsx`,
        data : this.newAirSafetyAndHealthChartData,
        table_header_text : this.newAirSafetyAndHealthChartData?.text_header
      })
      swal.close();
    },

    async downloadSafetyHealthSummary(){
      swal.fire({
        'title': `Exporting Safety & Health Summary`,
        'text': "Please wait...",
        'imageUrl': "https://img.icons8.com/color/400/pie-chart--v1.png",
        'imageWidth': 100,
        'imageHeight': 100,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading();

      try {
        const chartContainer1 = this.$refs.noOfInjuriesIllnessChart;
        const chartContainer2 = this.$refs.noOfInjuriesByRankChart;
        const chartContainer3 = this.$refs.noOfIllnessesByRankChart;
        const chartContainer4 = this.$refs.noOfInjuriesByManningChart;
        const chartContainer5 = this.$refs.noOfIllnessesByManningChart;
        const chartContainer6 = this.$refs.lossWorkingCaseChart;
        const chartContainer7 = this.$refs.noOfInjuryChart;
        const chartContainer8 = this.$refs.noOfIllnessChart;
        try {
          const canvas1 = await html2canvas(chartContainer1);
          const imageDataURL1 = canvas1.toDataURL('image/png');

          const canvas2 = await html2canvas(chartContainer2);
          const imageDataURL2 = canvas2.toDataURL('image/png');

          const canvas3 = await html2canvas(chartContainer3);
          const imageDataURL3 = canvas3.toDataURL('image/png');

          const canvas4 = await html2canvas(chartContainer4);
          const imageDataURL4 = canvas4.toDataURL('image/png');

          const canvas5 = await html2canvas(chartContainer5);
          const imageDataURL5 = canvas5.toDataURL('image/png');

          const canvas6 = await html2canvas(chartContainer6);
          const imageDataURL6 = canvas6.toDataURL('image/png');

          const canvas7 = await html2canvas(chartContainer7);
          const imageDataURL7 = canvas7.toDataURL('image/png');

          const canvas8 = await html2canvas(chartContainer8);
          const imageDataURL8 = canvas8.toDataURL('image/png');

          await this.sendImageToLaravel({
            image1: imageDataURL1,
            image2: imageDataURL2,
            image3: imageDataURL3,
            image4: imageDataURL4,
            image5: imageDataURL5,
            image6: imageDataURL6,
            image7: imageDataURL7,
            image8: imageDataURL8,
          });

        } catch (error) {
          console.error('Error converting div to image:', error);
        }
      } catch (error) {
        console.error('An error occurred during one of the operations:', error);
      }
    },

    async sendImageToLaravel(imageData) {
      try {
        const response = await axios.post('/kids/printAccidentSafetyAndHealthCharts', imageData, {
          responseType: 'blob',
        });
        swal.close();
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.download = `summary_report_${Date.now()}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error sending image to controller:', error);
      }
    },
  },


  async created() {
    const allChartsData = await DashboardService.getAccidentCharts({
      safety_and_health_module : true
    });

    this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_GRAPH_CHART_DATA', {
      key : 'injury_and_illnesses',
      value : allChartsData['injury_and_illnesses']
    })

    this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_GRAPH_CHART_DATA', {
      key : 'loss_working_case',
      value : allChartsData['loss_working_case']
    })

    this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_GRAPH_CHART_DATA', {
      key : 'number_of_injury_part',
      value : allChartsData['number_of_injury_part']
    })

    this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_GRAPH_CHART_DATA', {
      key : 'number_of_illness_part',
      value : allChartsData['number_of_illness_part']
    })

    this.$store.commit('SET_AIR_SAFETY_AND_HEALTH_GRAPH_DATA_LOADING', false);
  },
  computed : {
    ...mapGetters([
      'airSafetyAndHealthChartData',
      'airSafetyAndHealthDataLoading',
      'airSafetyAndHealthGraphDataLoading',
      'cmsRequestedOnBoardCrew',
      'airSafetyAndHealthGraphChartDataPayload',
    ]),
    newAirSafetyAndHealthChartData() {
      if (this.airSafetyAndHealthChartData.length === 0) {
        return [];
      }
      const injuryAndIllnessesModule = [
        'injury_and_illnesses',
        'number_of_injuries_by_rank',
        'number_of_illnesses_by_rank',
      ];
      if (injuryAndIllnessesModule.includes(this.airSafetyAndHealthChartData.safety_and_health_module)) {
        let newData = Object.assign({}, this.airSafetyAndHealthChartData);
        if (this.airSafetyAndHealthChartData.safety_and_health_module !== 'injury_and_illnesses') {
          if (this.selectedYear !== null) {
            newData.data = newData.data.filter(item => {
              const filteredAccidentIncident = item.accident_incidents.filter(accident_incident => {
                return new Date(accident_incident.event_date).getFullYear() === this.selectedYear
              })
              return filteredAccidentIncident.length > 0
            });
          }
        }
        return newData;
      }

      let newData = Object.assign({}, this.airSafetyAndHealthChartData);
      if (this.selectedYear !== null) {
        newData.data = newData.data.filter(item => item.year === this.selectedYear);
      }

      newData.data = newData.data.flatMap(item => item.values);
      return newData;
    }
  }
}
</script>

<template>
  <div>
    <div class="card shadow-sm mb-4">
      <div class="card-body pb-2">
        <div>
          <div class="row mb-3" v-if="!airSafetyAndHealthGraphDataLoading && ['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
            <div class="col-12">
                <button class="e-btn-primary e-btn float-right text-uppercase font-weight-bold force-white-all" @click="downloadSafetyHealthSummary">
                  <font-awesome-icon class="mr-1" icon="download"/>
                  Download Graphs Summary
                </button>
            </div>
          </div>
          <div v-if="airSafetyAndHealthGraphDataLoading">
            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <app-loading :html-message="`<p class='m-0' style='font-weight: bold; font-size: 15px'>GRAPH LOADING</p><span>Fetching CMS data, Please wait...</span>`"></app-loading>
              </div>
            </div>
            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <app-loading :html-message="`<p class='m-0' style='font-weight: bold; font-size: 15px'>GRAPH LOADING</p><span>Fetching CMS data, Please wait...</span>`"></app-loading>
              </div>
            </div>
            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <app-loading :html-message="`<p class='m-0' style='font-weight: bold; font-size: 15px'>GRAPH LOADING</p><span>Fetching CMS data, Please wait...</span>`"></app-loading>
              </div>
            </div>
            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <app-loading :html-message="`<p class='m-0' style='font-weight: bold; font-size: 15px'>GRAPH LOADING</p><span>Fetching CMS data, Please wait...</span>`"></app-loading>
              </div>
            </div>
            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <app-loading :html-message="`<p class='m-0' style='font-weight: bold; font-size: 15px'>GRAPH LOADING</p><span>Fetching CMS data, Please wait...</span>`"></app-loading>
              </div>
            </div>
            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <app-loading :html-message="`<p class='m-0' style='font-weight: bold; font-size: 15px'>GRAPH LOADING</p><span>Fetching CMS data, Please wait...</span>`"></app-loading>
              </div>
            </div>
            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <app-loading :html-message="`<p class='m-0' style='font-weight: bold; font-size: 15px'>GRAPH LOADING</p><span>Fetching CMS data, Please wait...</span>`"></app-loading>
              </div>
            </div>
            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <app-loading :html-message="`<p class='m-0' style='font-weight: bold; font-size: 15px'>GRAPH LOADING</p><span>Fetching CMS data, Please wait...</span>`"></app-loading>
              </div>
            </div>
          </div>
          <div v-else>
            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <div ref="noOfInjuriesIllnessChart">
                  <number-of-injuries-illnesses/>
                </div>
              </div>
            </div>

            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <div ref="noOfInjuriesByRankChart">
                  <number-of-injuries-by-rank/>
                </div>
              </div>
            </div>

            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <div ref="noOfIllnessesByRankChart">
                  <number-of-illnesses-by-rank/>
                </div>
              </div>
            </div>

            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <div ref="noOfInjuriesByManningChart">
                  <number-of-injuries-by-manning/>
                </div>
              </div>
            </div>

            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <div ref="noOfIllnessesByManningChart">
                  <number-of-illnesses-by-manning/>
                </div>
              </div>
            </div>

            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <div ref="lossWorkingCaseChart">
                  <loss-working-case/>
                </div>
              </div>
            </div>

            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <div ref="noOfInjuryChart">
                  <number-of-injury-part/>
                </div>
              </div>
            </div>

            <div class="card shadow-sm mb-4">
              <div class="card-body pb-2">
                <div ref="noOfIllnessChart">
                  <number-of-illness-part/>
                </div>
              </div>
            </div>
          </div>




        </div>
      </div>
    </div>

    <div class="modal fade" id="safetyAndHealthModal" tabindex="-1" aria-labelledby="safetyAndHealthModal" aria-hidden="true">
      <div class="modal-dialog modal-xxl modal-dialog-centered" style="max-width: 80vw;">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-uppercase" id="exampleModalLabel">{{ newAirSafetyAndHealthChartData?.text_header }}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="selectedYear = null">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row align-item-center mb-2">
              <div class="col-auto" v-if="newAirSafetyAndHealthChartData?.safety_and_health_module !== 'injury_and_illnesses'">
                <select name="year" id="year" class="form-control form-control-sm" v-model="selectedYear">
                  <option :value="null">{{Math.min(...years)}}-{{Math.max(...years)}}</option>
                  <option :value="year" v-for="year in years">
                    {{year}}
                  </option>
                </select>
              </div>
              <div class="col-auto">
                <button class="btn btn-dark btn-sm force-white-all" :disabled="!newAirSafetyAndHealthChartData?.data?.length || airSafetyAndHealthDataLoading === true" @click.prevent="generateCsv"><font-awesome-icon icon="download" class="mr-2"></font-awesome-icon>DOWNLOAD CSV</button>
              </div>
            </div>

            <div class="modal-table-container">
              <table class="small e-tbl">
                <thead class="bg-white" style="position: sticky; top: 0; z-index: 2">
                <template>
                  <tr>
                    <th class="align-middle text-center" rowspan="3" style="width: 1em" scope="col">#</th>
                    <th class="align-middle text-center" colspan="6" scope="col">PERSONNEL</th>
                    <th class="align-middle text-center" rowspan="3" scope="col">VESSEL</th>
                    <th class="align-middle text-center" rowspan="3" scope="col">MANAGER</th>
                    <th class="align-middle text-center" rowspan="3" scope="col">REPORT NUMBER</th>
                    <th class="align-middle text-center" rowspan="3" scope="col">REPORT TITLE</th>
                    <th class="align-middle text-center" rowspan="3" scope="col">EVENT DATE</th>
                    <th class="align-middle text-center" rowspan="3" scope="col">ACTION</th>
                  </tr>
                  <tr>
                    <th class="align-middle text-center" rowspan="2" scope="col">NAME</th>
                    <th class="align-middle text-center" rowspan="2" scope="col">RANK</th>
                    <th class="align-middle text-center" rowspan="2" scope="col">AGE</th>
                    <th class="align-middle text-center" colspan="3" scope="col">YEARS OF EXP (CURRENT RANK)</th>
                  </tr>
                  <tr>
                    <th class="align-middle text-center" scope="col">YEARS</th>
                    <th class="align-middle text-center" scope="col">MONTHS</th>
                    <th class="align-middle text-center" scope="col">DAYS</th>
                  </tr>
                </template>
                </thead>
                <tbody>
                <template v-if="airSafetyAndHealthDataLoading === true">
                  <tr>
                    <td colspan="100%">
                      <app-loading></app-loading>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <template v-if="newAirSafetyAndHealthChartData?.data?.length === 0">
                    <tr>
                      <td colspan="100%" class="align-middle text-center">
                        <p class="h5 py-1">NO RESULTS FOUND</p>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <template v-for="(data, index) in newAirSafetyAndHealthChartData?.data">
                      <template v-for="(accident_incident, accident_incident_index) in data.accident_incidents">
                        <tr>
                          <template v-if="accident_incident_index === 0">
                            <td class="align-middle text-center" :rowspan="data.accident_incidents.length">{{ index + 1 }}</td>
                            <td class="align-middle text-center" :rowspan="data.accident_incidents.length">{{ data.cms_crew_full_name }}</td>
                            <td class="align-middle text-center text-uppercase" :rowspan="data.accident_incidents.length">{{ data.rank_alias1 }}</td>
                            <td class="align-middle text-center text-uppercase" :rowspan="data.accident_incidents.length">{{ data?.age }}</td>
                            <td class="align-middle text-center text-uppercase" :rowspan="data.accident_incidents.length">{{ data?.years_of_exp?.years }}</td>
                            <td class="align-middle text-center text-uppercase" :rowspan="data.accident_incidents.length">{{ data?.years_of_exp?.months }}</td>
                            <td class="align-middle text-center text-uppercase" :rowspan="data.accident_incidents.length">{{ data?.years_of_exp?.days }}</td>
                          </template>
                          <template>
                            <td class="align-middle text-center">{{ accident_incident.vessel_name?.toUpperCase() }}</td>
                            <td class="align-middle text-center">{{ accident_incident.management_office_name?.toUpperCase() }}</td>
                            <td class="align-middle text-center">{{ accident_incident.report_number }}</td>
                            <td class="align-middle text-center">{{ accident_incident.title }}</td>
                            <td class="align-middle text-center">{{ accident_incident.event_date }}</td>
                            <td class="align-middle text-center">
                              <button class="e-btn e-btn-blue e-btn-sm e-text-white my-1" @click="showReport(accident_incident.id)">
                                <font-awesome-icon icon="eye"  />
                                View
                              </button>
                            </td>
                          </template>
                        </tr>
                      </template>
                    </template>
                  </template>
                </template>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped>
.e-tbl  thead tr th {
  border: 1px solid #b1b1b1;
}

.modal-table-container {
  max-height: 70vh;
  overflow-y: auto;
}
</style>
